import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Paper,
  Tabs,
  Tab,
  Typography,
  TextField,
  Grid,
  MenuItem,
  IconButton,
  Tooltip,
  CircularProgress,
  Alert,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { authenticationService } from "src/services";
import { get, multy_put, put } from "src/services/httpClient.service";
import { useSnackbar } from "src/components/snackbar/useSnackbar";
import Paymentgatwaylist from "../Paymentgatway";
import { useAppConfig } from "src/components/AppConfigContext/AppConfigContext";


const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

// Mock JSON templates
const MOCK_EMAIL_CONFIG = {
  "credentials": {
    "sender_id": "[CLIENT_UPDATE_SENDER_ID]",
    "sender_password": "[CLIENT_UPDATE_SENDER_PASSWORD]"
  },
  "change_password": {
    "body": "<p>Your password has been changed successfully.<br />If you did not make this change, please contact support immediately.</p>",
    "subject": "[SUBJECT]",
    "signature": "[SIGNATURE]",
    "hello_text": "Dear {USER_NAME},"
  },
  "forgot_password": {
    "body": "<p>Hi, {USER_EMAIL} your password has been regenerated. New password is <b>{PASSWORD}</b></p>",
    "subject": "[SUBJECT]",
    "signature": "[SIGNATURE]",
    "hello_text": "Hello {USER_NAME},"
  },
  "send_credentials": {
    "body": "<p>These are the credentials<br />Username: {USER_EMAIL}<br />Password: <b>{PASSWORD}</b></p>",
    "subject": "[SUBJECT]",
    "signature": "[SIGNATURE]",
    "hello_text": "Hello {USER_NAME},"
  }
};

const MOCK_SMS_CONFIG = {
  "type": "TrustSignal",
  "login_otp": {
    "body": "{OTP} is the OTP to login using your mobile number on {COMPANY_SHORT_NAME} Network. Valid for one time use. Do not share with anyone.{SENDER_ID}.Thanks {SIGNATURE}",
    "route": "otp",
    "api_key": "69471b30-b9b6-42d4-8107-8f6f11e066c9",
    "isdesturl": "true",
    "sender_id": "OTPDIG",
    "signature": "[SIGNATURE]",
    "template_id": "1507166555893680796"
  },
  "company_name": "[COMPANY_NAME]",
  "company_short_name": "[COMPANY_SHORT_NAME]"
};

const ApplicationConfig = () => {
  const { showSnackbar } = useSnackbar();

  const [hasCustomRegCodeAccess, setHasCustomRegCodeAccess] = useState(false);
  const [hasDeviceRestriction, setHasDeviceRestriction] = useState(true);
  const [hasCustomPasswordAccess, setHasCustomPasswordAccess] = useState(false);
  const [hasOwnerCommissionAccess, setOwnerCommissionAccess] = useState(true);
  const [enablePaymentGateway, setEnablePaymentGateway] = useState(false);
  const [enableUserWallet, setEnableUserWallet] = useState(false);
  

  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingCompanyInfo, setLoadingCompanyInfo] = useState(false);

  //type
  const getConfigType = () => {
  switch (activeTab) {
    case 0:
      return "GENERAL";
    case 1:
      return "COMPANY_INFO";
    case 2:
      return "FILE_UPLOAD";
    case 3:
      return "EMAIL_CONFIG";
    case 4:
      return "SMS_CONFIG";
    case 5:
      return "PRIVACY_POLICY";
    case 6:
      return "TERMS_CONDITIONS";
    case 7:
      return "REFUND_POLICY";
   /*  case 8:
      return "GATEWAY_CONFIG"; */
    // case 8:
    //   return "VERSION_CONTROLL";
    default:
      return "GENERAL";
  }
};

  // HTML editors
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [terms, setTerms] = useState("");
  const [refundPolicy, setRefundPolicy] = useState("");

  // Config fields
  const [drmConfig, setDrmConfig] = useState("");
  const [smsConfig, setSmsConfig] = useState("");
  const [emailConfig, setEmailConfig] = useState("");

  const [recordId, setRecordId] = useState(null);
  const { vendorId } = authenticationService.getVendorFranchiseIds();

  const [emailError, setEmailError] = useState(false);
  const [smsError, setSmsError] = useState(false);
  const [drmError, setDrmError] = useState(false);

  // File Upload Tab States
  const [rootPath, setRootPath] = useState(true);
  const [fileBasePath, setFileBasePath] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  const [faviconFile, setFaviconFile] = useState(null);
  const [logoFileUrl, setLogoFileUrl] = useState("");
  const [faviconFileUrl, setFaviconFileUrl] = useState("");

  //---- General Setting
  const [registrationName, setRegistrationName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyShortName, setCompanyShortName] = useState("");
  const [deviceMaxLoginLimit, setDeviceMaxLoginLimit] = useState<any>();
  const [landingPageChannel, setLandingPageChannel] = useState("");
  const [uiUrl, setUiUrl] = useState("");
  const [crmUrl, setCrmUrl] = useState("");
  const [drmUrl, setDrmUrl] = useState("");
  const [redisUrl, setRedisUrl] = useState("");
  
  //---- Company Info Settings
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyCity, setCompanyCity] = useState("");
  const [companyState, setCompanyState] = useState("");
  const [companyPincode, setCompanyPincode] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyGst, setCompanyGst] = useState("");

  // For fetching channels
  const [channels, setChannels] = useState([]);
  const [loadingChannels, setLoadingChannels] = useState(false);

  //device restrict
  const [restrictDeviceLimit, setRestrictDeviceLimit] = useState(false);
  const [previousLimit, setPreviousLimit] = useState("");
  

  // refs to revoke object URLs on unmount/change
  const logoBlobRef = useRef(null);
  const faviconBlobRef = useRef(null);

  // --- helpers ---
  const validateJson = (value) => {
    try {
      JSON.parse(value);
      return true;
    } catch (e) {
      return false;
    }
  };

  const beautifyJson = (value) => {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  };

  // Function to download JSON file
  const downloadJsonFile = (jsonData, filename) => {
    try {
      const dataStr = JSON.stringify(jsonData, null, 2);
      const dataBlob = new Blob([dataStr], { type: "application/json" });
      const url = URL.createObjectURL(dataBlob);
      
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setTimeout(() => URL.revokeObjectURL(url), 100);
      
      showSnackbar(`Downloaded ${filename} template`, "success");
    } catch (error) {
      console.error("Error downloading file:", error);
      showSnackbar("Failed to download template", "error");
    }
  };

  // Download mock email config
  const handleDownloadEmailMock = () => {
    downloadJsonFile(MOCK_EMAIL_CONFIG, "email-config-template.json");
  };

  // Download mock SMS config
  const handleDownloadSmsMock = () => {
    downloadJsonFile(MOCK_SMS_CONFIG, "sms-config-template.json");
  };

  // Insert mock template into the text field
  const handleInsertEmailTemplate = () => {
    setEmailConfig(JSON.stringify(MOCK_EMAIL_CONFIG, null, 2));
    setEmailError(false);
    showSnackbar("Email template inserted", "info");
  };

  const handleInsertSmsTemplate = () => {
    setSmsConfig(JSON.stringify(MOCK_SMS_CONFIG, null, 2));
    setSmsError(false);
    showSnackbar("SMS template inserted", "info");
  };

  // -----------------------------------------------------------------
  // Function to fetch channels
  // -----------------------------------------------------------------
  const fetchChannels = async () => {
    setLoadingChannels(true);
    try {
      const data = await get(`${API_BASE_URL}/channel/vendor/${vendorId}/findAll`);
      
      const allChannels = (data?.channelList ?? []).flatMap(group =>
        (group.channelData ?? []).map(ch => ({
          ...ch,
          category: group.category ?? ch.category ?? '',
          id: ch.id,
          channelId: ch.channelId,
          channelName: ch.channelName,
          isLandingChannel: ch.isLandingChannel || false
        }))
      );

      allChannels.sort((a, b) => a.channelName.localeCompare(b.channelName));
      
      setChannels(allChannels);
      
      if (landingPageChannel) {
        const channelExists = allChannels.some(ch => ch.id.toString() === landingPageChannel);
        if (!channelExists) {
          setLandingPageChannel("");
        }
      }
    } catch (err) {
      console.error("Error fetching channels:", err);
      showSnackbar("Failed to load channels", "error");
    } finally {
      setLoadingChannels(false);
    }
  };

  // -----------------------------------------------------------------
  // GET COMPANY INFO API
  // -----------------------------------------------------------------
  const fetchCompanyInfo = async () => {
    setLoadingCompanyInfo(true);
    try {
      const response = await get(
        `${API_BASE_URL}/api/application-config/vendor/${vendorId}/company-info`
      );
      
      if (response) {
        setCompanyAddress(response.companyAddress || "");
        setCompanyCity(response.companyCity || "");
        setCompanyState(response.companyState || "");
        setCompanyPincode(response.companyPincode || "");
        setCompanyPhone(response.companyPhone || "");
        setCompanyEmail(response.companyEmail || "");
        setCompanyGst(response.companyGst || "");
      }
    } catch (err) {
      console.error("❌ Error fetching company info:", err);
      // Don't show error if it's just not found (first time setup)
      if (err.response?.status !== 404) {
        showSnackbar("Failed to load company info", "error");
      }
    } finally {
      setLoadingCompanyInfo(false);
    }
  };

  // -----------------------------------------------------------------
  // UPDATE COMPANY INFO API
  // -----------------------------------------------------------------
  const handleUpdateCompanyInfo = async () => {
    try {
      setLoading(true);
      
      const payload = {
        companyAddress,
        companyCity,
        companyState,
        companyPincode,
        companyPhone,
        companyEmail,
        companyGst
      };

      const response = await put(
        `${API_BASE_URL}/api/application-config/vendor/${vendorId}/company-info`,
        payload
      );

      if (response) {
        showSnackbar("Company info updated successfully!", "success");
        // Refresh company info
        fetchCompanyInfo();
      }
    } catch (err) {
      console.error("Error updating company info:", err);
      showSnackbar("Failed to update company info", "error");
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------------------------------------------
  // GET API - load existing config
  // -----------------------------------------------------------------
  const getPolicyDetails = async () => {
    try {
      const response = await get(
        `${API_BASE_URL}/api/application-config/vendor/${vendorId}`
      );

      if (response) {
        setRecordId(response.id);

        // JSON fields (pretty print)
        setDrmConfig(beautifyJson(response.drmConfig));
        setSmsConfig(beautifyJson(response.smsConfig));
        setEmailConfig(beautifyJson(response.mailConfig ?? response.emailConfig));

        // HTML editors
        setPrivacyPolicy(response.privacyPolicy || "");
        setTerms(response.termsAndConditions || "");
        setRefundPolicy(response.refundPolicy || "");

        setFileBasePath(response.fileBasePath || "");
        setLogoFileUrl(response.logoFileUrl || "");
        setFaviconFileUrl(response.faviconFileUrl || "");

        setRegistrationName(response.registrationName || "");
        setCompanyName(response.companyName || "");
        setCompanyShortName(response.companyShortName || "");
        setDeviceMaxLoginLimit(response.deviceMaxLoginLimit?.toString() || "");
        setLandingPageChannel(response.landingPageChannel || "");
        setHasCustomRegCodeAccess(response.hasCustomRegCodeAccess === true);
        setHasDeviceRestriction(response.hasDeviceRestriction === true);
        setHasCustomPasswordAccess(response.hasCustomPasswordAccess === true);
        setOwnerCommissionAccess(response.hasOwnerCommissionAccess === true);
        setEnablePaymentGateway(response.enablePaymentGateway === true);
        setEnableUserWallet(response.enableUserWallet === true);

        setUiUrl(response.uiUrl || "");
        setCrmUrl(response.crmUrl || "");
        setDrmUrl(response.drmUrl || "");
        setRedisUrl(response.redisUrl || "");

        setCompanyAddress(response.companyAddress || "");
        setCompanyCity(response.companyCity || "");
        setCompanyState(response.companyState || "");
        setCompanyPincode(response.companyPincode || "");
        setCompanyPhone(response.companyPhone || "");
        setCompanyEmail(response.companyEmail || "");
        setCompanyGst(response.companyGst || "");
      }
    } catch (err) {
      console.error("❌ GET Error:", err);
      showSnackbar("Failed to load config", "error");
    }
  };

  useEffect(() => {
    getPolicyDetails();
    fetchChannels();
    fetchCompanyInfo(); // Fetch company info separately

    return () => {
      if (logoBlobRef.current) URL.revokeObjectURL(logoBlobRef.current);
      if (faviconBlobRef.current) URL.revokeObjectURL(faviconBlobRef.current);
    };
  }, []);

  // -----------------------------------------------------------------
  // File input handlers
  // -----------------------------------------------------------------
  const handleLogoChange = (e) => {
    const file = e.target.files?.[0] ?? null;
    setLogoFile(file);

    if (logoBlobRef.current) {
      URL.revokeObjectURL(logoBlobRef.current);
      logoBlobRef.current = null;
    }

    if (file) {
      const url = URL.createObjectURL(file);
      logoBlobRef.current = url;
      setLogoFileUrl(url);
    } else {
      setLogoFileUrl("");
    }
  };

  const handleFaviconChange = (e) => {
    const file = e.target.files?.[0] ?? null;
    setFaviconFile(file);

    if (faviconBlobRef.current) {
      URL.revokeObjectURL(faviconBlobRef.current);
      faviconBlobRef.current = null;
    }

    if (file) {
      const url = URL.createObjectURL(file);
      faviconBlobRef.current = url;
      setFaviconFileUrl(url);
    } else {
      setFaviconFileUrl("");
    }
  };

  // -----------------------------------------------------------------
  // UPDATE (PUT) - Full config update
  // -----------------------------------------------------------------
  const handleUpdate = async () => {
    const type = getConfigType();
    try {
      if (!recordId) {
        showSnackbar("No existing record to update!", "error");
        return;
      }

      if (emailError || smsError || drmError) {
        showSnackbar("Fix JSON errors before saving", "error");
        return;
      }

      setLoading(true);

      /* const payload = {
        id: recordId,
        tabType:type,
        privacyPolicy,
        termsAndConditions: terms,
        refundPolicy,
        drmConfig,
        smsConfig,
        mailConfig: emailConfig,
        vendorId,
        fileBasePath,
        registrationName,
        companyName,
        companyShortName,
        deviceMaxLoginLimit,
        landingPageChannel,
        companyAddress,
        companyCity,
        companyState,
        companyPincode,
        companyPhone,
        companyEmail,
        companyGst,
        hasCustomRegCodeAccess: hasCustomRegCodeAccess,
        hasDeviceRestriction: hasDeviceRestriction,
        // Company info fields are now handled by separate API
      }; */

      const payload: any = {
  id: recordId,
  tabType: type,
  vendorId,
};

// Send only required payload based on tab type
if (type === "PRIVACY_POLICY") {
  payload.privacyPolicy = privacyPolicy;
}

if (type === "TERMS_CONDITIONS") {
  payload.termsAndConditions = terms;
}

if (type === "REFUND_POLICY") {
  payload.refundPolicy = refundPolicy;
}

if (type === "EMAIL_CONFIG") {
  payload.mailConfig = emailConfig;
}

if (type === "SMS_CONFIG") {
  payload.smsConfig = smsConfig;
}

if (type === "FILE_UPLOAD") {
  payload.fileBasePath = fileBasePath;
}

if (type === "GENERAL") {
  payload.registrationName = registrationName;
  payload.companyName = companyName;
  payload.companyShortName = companyShortName;
  payload.deviceMaxLoginLimit = deviceMaxLoginLimit;
  payload.landingPageChannel = landingPageChannel;
  payload.hasCustomRegCodeAccess = hasCustomRegCodeAccess;
  payload.hasDeviceRestriction = hasDeviceRestriction;
  payload.hasCustomPasswordAccess = hasCustomPasswordAccess;
  payload.hasOwnerCommissionAccess = hasOwnerCommissionAccess;
  payload.enablePaymentGateway = enablePaymentGateway;
  payload.enableUserWallet = enableUserWallet;

  payload.uiUrl = uiUrl;
  payload.crmUrl = crmUrl;
  payload.drmUrl = drmUrl;
  payload.redisUrl = redisUrl;
}

if (type === "COMPANY_INFO") {
  payload.companyAddress = companyAddress;
  payload.companyCity = companyCity;
  payload.companyState = companyState;
  payload.companyPincode = companyPincode;
  payload.companyPhone = companyPhone;
  payload.companyEmail = companyEmail;
  payload.companyGst = companyGst;
}

      console.log('payload1',payload)

      const formData = new FormData();
      formData.append("configDTO", JSON.stringify(payload));

      if (logoFile) formData.append("logo", logoFile);
      if (faviconFile) formData.append("favicon", faviconFile);

      const response = await multy_put(
        `${API_BASE_URL}/api/application-config/updateConfigById/${recordId}`,
        formData
      );

      if (["OK"].includes(response?.status)) {
        showSnackbar("Updated successfully!", "success");
        getPolicyDetails();
        window.dispatchEvent(new Event("APP_LOGO_UPDATED"));
      } else {
        console.error("Update failed:", response);
        showSnackbar("Update failed!", "error");
      }
    } catch (err) {
      console.error("Error updating data:", err);
      showSnackbar("Error updating data!", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 3, maxWidth: "90%", margin: "30px auto" }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
        ⚙️ Application Config
      </Typography>

      {/* Tabs */}
      <Box  sx={{
    width: "100%",
    overflowX: "auto",
    borderBottom: 1,
    borderColor: "divider",
    marginBottom:'20px',
    /* ---- Scrollbar Styling ---- */
    "&::-webkit-scrollbar": {
      height: 6,
    },
    "&::-webkit-scrollbar-track": {
     
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb": {
    
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      
    },

    /* Firefox */
    scrollbarWidth: "thin",
   
  }}>
    <Tabs
        value={activeTab}
        onChange={(e, val) => setActiveTab(val)}
        sx={{
        minWidth: "max-content", // important for scroll
         }}
      >
        <Tab label="General" />
        <Tab label="Company Info" />
        <Tab label="File Upload" />
        <Tab label="Email Config" />
        <Tab label="SMS Config" />
        <Tab label="Privacy Policy" />
        <Tab label="Terms & Conditions" />
        <Tab label="Refund Policy" />
        {/* <Tab label="Version Controll" /> */}
        {/* <Tab label="Gateway Config" /> */}
      </Tabs>
  </Box>

      

      {/* General Tab */}
      {activeTab === 0 && (
        <>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            General Settings
          </Typography>

          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Box sx={{ maxWidth: 500 }}>
                <TextField
                  label="Registration Name"
                  value={registrationName}
                  onChange={(e) => setRegistrationName(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                />

                <TextField
                  label="Company Name"

                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                />

                <TextField
                  label="Company Short Name"
                  value={companyShortName}
                  onChange={(e) => setCompanyShortName(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                  InputProps={{
                   readOnly: true,
                  }}
                />

                <TextField
                  label="Application URL"

                  value={uiUrl}
                  onChange={(e) => setUiUrl(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                />

                <TextField
                  label="Backend URL"

                  value={crmUrl}
                  onChange={(e) => setCrmUrl(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                />

                <TextField
                  label="DRM URL"

                  value={drmUrl}
                  onChange={(e) => setDrmUrl(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                />

                <TextField
                  label="REDIS URL"

                  value={redisUrl}
                  onChange={(e) => setRedisUrl(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ maxWidth: 500 }}>
                {/* <TextField
                  label="Device Max Login Limit"
                  value={deviceMaxLoginLimit}
                  onChange={(e) => setDeviceMaxLoginLimit(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                  type="number"
                  inputProps={{ min: 1 }}
                /> */}

               {/*  <FormControlLabel
  control={
    <Checkbox
  checked={hasDeviceRestriction}
  onChange={(e) => {
    const checked = e.target.checked;

    if (checked) {
      setPreviousLimit(deviceMaxLoginLimit);
      setDeviceMaxLoginLimit("1"); // keep string
    } else {
      setDeviceMaxLoginLimit(previousLimit || "");
    }

    setHasDeviceRestriction(checked);
  }}
/>
  }
  label="Restrict Device Limit"
/> */}

{/* Show only when NOT restricted */}
{!hasDeviceRestriction && (
  <TextField
    label="Device Max Login Limit"
    value={deviceMaxLoginLimit || ""}
    onChange={(e) => setDeviceMaxLoginLimit(e.target.value)}
    fullWidth
    sx={{ mb: 2 }}
    type="number"
    InputLabelProps={{ shrink: true }}  // 🔥 prevents overlap
    inputProps={{ min: 1 }}
  />
)}

                <TextField
                  select
                  label="Landing Page Channel"
                  value={landingPageChannel}
                  onChange={(e) => setLandingPageChannel(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                  disabled={loadingChannels}
                  helperText={loadingChannels ? "Loading channels..." : "Select a channel to set as landing page"}
                >
                  <MenuItem value="">
                    <em>None (No landing channel)</em>
                  </MenuItem>
                  {channels.map((channel) => (
                    <MenuItem key={channel.id} value={channel.id}>
                      {channel.channelName} ({channel.category})
                    </MenuItem>
                  ))}
                </TextField>

<FormControlLabel
  control={
    <Checkbox
      checked={hasCustomRegCodeAccess}
      onChange={(e) => setHasCustomRegCodeAccess(e.target.checked)}
    />
  }
  label="Allow LCO Registration Code"
/>

<FormControlLabel
  control={
    <Checkbox
      checked={hasCustomPasswordAccess}
      onChange={(e) => setHasCustomPasswordAccess(e.target.checked)}
    />
  } label="Disable Auto-generate Passwords" 
/>
<FormControlLabel
  control={
    <Checkbox
      checked={enablePaymentGateway}
      onChange={(e) => setEnablePaymentGateway(e.target.checked)}
    />
  } label="Enable Payment Gateway" 
/>
<FormControlLabel
  control={
    <Checkbox
      checked={enableUserWallet}
      onChange={(e) => setEnableUserWallet(e.target.checked)}
    />
  } label="Enable User Wallet" 
/>
              </Box>
            </Grid>
          </Grid>

          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleUpdate}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Save General Settings"}
            </Button>
          </Box>
        </>
      )}

      {/* Company Info Tab */}
      {activeTab === 1 && (
        <>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="subtitle1">
              Company Information
            </Typography>
            {loadingCompanyInfo && <CircularProgress size={24} />}
          </Box>

          {!loadingCompanyInfo && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  label="Company Address"
                  value={companyAddress}
                  onChange={(e) => setCompanyAddress(e.target.value)}
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Enter complete address"
                />
              </Grid>
              
              <Grid item xs={12} md={4}>
                <TextField
                  label="City"
                  value={companyCity}
                  onChange={(e) => setCompanyCity(e.target.value)}
                  fullWidth
                  placeholder="City"
                />
              </Grid>
              
              <Grid item xs={12} md={4}>
                <TextField
                  label="State"
                  value={companyState}
                  onChange={(e) => setCompanyState(e.target.value)}
                  fullWidth
                  placeholder="State"
                />
              </Grid>
              
              <Grid item xs={12} md={4}>
                <TextField
                  label="Pincode"
                  value={companyPincode}
                  onChange={(e) => setCompanyPincode(e.target.value)}
                  fullWidth
                  placeholder="Pincode"
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  label="Phone Number"
                  value={companyPhone}
                  onChange={(e) => setCompanyPhone(e.target.value)}
                  fullWidth
                  placeholder="Contact number"
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  label="Email"
                  value={companyEmail}
                  onChange={(e) => setCompanyEmail(e.target.value)}
                  fullWidth
                  placeholder="Company email"
                  type="email"
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  label="GST Number"
                  value={companyGst}
                  onChange={(e) => setCompanyGst(e.target.value)}
                  fullWidth
                  placeholder="GSTIN"
                />
              </Grid>
              
              <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end" gap={2}>
                  <Button 
                    variant="outlined" 
                    onClick={fetchCompanyInfo}
                    disabled={loading}
                  >
                    Reset
                  </Button>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={handleUpdateCompanyInfo}
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={24} /> : "Update Company Info"}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          )}
        </>
      )}

      {/* File Upload Tab */}
      {activeTab === 2 && (
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            File Upload Settings
          </Typography>

          <TextField
            label="File Base Path"
            fullWidth
            value={fileBasePath}
            onChange={(e) => setFileBasePath(e.target.value)}
            sx={{ mb: 3 }}
          />

          <Box mb={3}>
            <Typography sx={{ mb: 1 }}>Logo (212*52)</Typography>
            <input
              type="file"
              accept="image/*"
              onChange={handleLogoChange}
            />
            {logoFileUrl && (
              <Box mt={1}>
                <Typography variant="body2">Preview:</Typography>
                <img
                  src={logoFileUrl}
                  alt="logo preview"
                  style={{ maxHeight: 80, marginTop: 6 }}
                />
              </Box>
            )}
          </Box>

          <Box mb={3}>
            <Typography sx={{ mb: 1 }}>Favicon Upload</Typography>
            <input
              type="file"
              accept="image/*"
              onChange={handleFaviconChange}
            />
            {faviconFileUrl && (
              <Box mt={1}>
                <Typography variant="body2">Preview:</Typography>
                <img
                  src={faviconFileUrl}
                  alt="favicon preview"
                  style={{ maxHeight: 48, marginTop: 6 }}
                />
              </Box>
            )}
          </Box>

          <Box display="flex" justifyContent="flex-end">
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleUpdate}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Save File Settings"}
            </Button>
          </Box>
        </Box>
      )}

      {/* Email Config Tab */}
      {activeTab === 3 && (
        <Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography variant="subtitle1">Email Config (JSON Format)</Typography>
            <Box>
              <Tooltip title="Insert template into editor">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleInsertEmailTemplate}
                  sx={{ mr: 1 }}
                >
                  Insert Template
                </Button>
              </Tooltip>
              <Tooltip title="Download JSON template">
                <IconButton 
                  color="primary" 
                  onClick={handleDownloadEmailMock}
                  size="small"
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
          
          
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            <pre>
              {`- Only modify values inside [] brackets. Do not change values inside {} braces because they are dynamic system variables.`}
            </pre>
            <pre>
            {
              `- Use this JSON configuration for email service setup. The template includes placeholders for SMTP settings and email templates.`
            }
            </pre>
          </Typography>
          
          <TextField
            fullWidth
            multiline
            minRows={12}
            label="Email Configuration JSON"
            value={emailConfig}
            error={emailError}
            helperText={emailError ? "Invalid JSON format" : ""}
            onChange={(e) => {
              const val = e.target.value;
              setEmailConfig(val);
              setEmailError(!validateJson(val));
            }}
            onBlur={() => !emailError && setEmailConfig(beautifyJson(emailConfig))}
          />
          
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleUpdate}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Save Email Config"}
            </Button>
          </Box>
        </Box>
      )}

      {/* SMS Config Tab */}
      {activeTab === 4 && (
        <Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography variant="subtitle1">SMS Config (JSON Format)</Typography>
            <Box>
              <Tooltip title="Insert template into editor">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleInsertSmsTemplate}
                  sx={{ mr: 1 }}
                >
                  Insert Template
                </Button>
              </Tooltip>
              <Tooltip title="Download JSON template">
                <IconButton 
                  color="primary" 
                  onClick={handleDownloadSmsMock}
                  size="small"
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
          
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            <pre>
              {`- Only modify values inside [] brackets. Do not change values inside {} braces because they are dynamic system variables.`}
            </pre>
            <pre>
            {
              `- Use this JSON configuration for SMS service setup. The template includes placeholders for SMS Provider settings and templates.`
            }
            </pre>
          </Typography>
          
          <TextField
            fullWidth
            multiline
            minRows={12}
            label="SMS Configuration JSON"
            value={smsConfig}
            error={smsError}
            helperText={smsError ? "Invalid JSON format" : ""}
            onChange={(e) => {
              const val = e.target.value;
              setSmsConfig(val);
              setSmsError(!validateJson(val));
            }}
            onBlur={() => !smsError && setSmsConfig(beautifyJson(smsConfig))}
          />
          
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleUpdate}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Save SMS Config"}
            </Button>
          </Box>
        </Box>
      )}

      {/* Privacy Policy Tab */}
      {activeTab === 5 && (
        <>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>Privacy Policy</Typography>
          <ReactQuill value={privacyPolicy} onChange={setPrivacyPolicy} />
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleUpdate}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Save Privacy Policy"}
            </Button>
          </Box>
        </>
      )}

      {/* Terms & Conditions Tab */}
      {activeTab === 6 && (
        <>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>Terms & Conditions</Typography>
          <ReactQuill value={terms} onChange={setTerms} />
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleUpdate}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Save Terms & Conditions"}
            </Button>
          </Box>
        </>
      )}

      {/* Refund Policy Tab */}
      {activeTab === 7 && (
        <>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>Refund Policy</Typography>
          <ReactQuill value={refundPolicy} onChange={setRefundPolicy} />
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleUpdate}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Save Refund Policy"}
            </Button>
          </Box>
        </>
      )}

       {/* {activeTab === 8 && (
        <>
          <Paymentgatwaylist/>
        </>
      )} */}
       {/* {activeTab === 8 && (
        <>
          <CrmVersionControll/>
        </>
      )} */}
    </Paper>
  );
};

export default ApplicationConfig;